import { SettingController } from './setting.controller';
export class SettingsEmbeddedManager {
    constructor(config) {
        this.config = config;
        this.settings = new Map();
    }
    async init(context) {
        this.context = context;
    }
    getSetting(name, initialValue) {
        if (!this.context)
            throw new Error('SettingsManager.getSetting Error: context is not initialized');
        if (this.settings.has(name))
            return this.settings.get(name);
        const setting = new SettingController(name, initialValue);
        setting.init(this.context).then();
        this.settings.set(name, setting);
        return setting;
    }
}
//# sourceMappingURL=settings-embedded.manager.js.map